var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.border ? 'grid-container' : 'grid-container borderless'},[_c('ul',{class:{
        setLeftTabs: _vm.leftAlign == true,
        tabs__header: _vm.leftAlign == false,
        setBackground: _vm.background == false
      },style:([_vm.calculateWidth, _vm.disabled ? _vm.divDisable : '' ])},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,class:{
          tab__selected: index == _vm.selectedIndex,
          large: _vm.largeTabs == true,
          borderless__right: _vm.border == false,
        },style:({ fontSize: _vm.titleSize + 'px' }),attrs:{"id":"tab"},on:{"click":function($event){_vm.selectTab(index,tab); _vm.selectedTab(index,tab)}}},[(tab.icon)?_c('img',{staticClass:"icon",attrs:{"src":_vm.getImgUrl(tab.icon)}}):_vm._e(),_vm._v(" "+_vm._s(tab.title)+" ")])}),0)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }